interface DataCardProps {
  title: string
  value: string
  description: string
}

export default function DataCard({ title, value, description }: DataCardProps) {
  return (
    <div className="bg-[rgba(255,255,255,0.16)] backdrop-blur-[22px] border border-[rgba(255,255,255,0.22)] rounded-card p-6 text-[#f8fbff]">
      <h4 className="text-[0.85rem] uppercase tracking-[0.14em] opacity-80 mb-2.5 m-0">
        {title}
      </h4>
      <strong className="block text-[2rem] leading-tight">
        {value}
      </strong>
      <span className="block mt-1.5 text-[0.9rem] text-[rgba(248,251,255,0.8)]">
        {description}
      </span>
    </div>
  )
}
